import React from "react";
import { styled } from "../../stitches.config";
import { bodyLarge, h3 } from "../commonStyles/Fonts";

import Dots from "../assets/icons/dots-right.svg"
import Link from "../../components/Link"

type ExtendedProps = {
    href?: string;
    title?: string;
    backgroundSrc?: string;
};
interface AtavistNextBridProps {
    blockData: ExtendedProps;
}

export const AtavistNextBrid: React.FC<AtavistNextBridProps> = ({
    blockData,
}) => {

    const {
        href,
        backgroundSrc,
        title
    } = blockData;

    return (
        <AtavistBridInfoWrapper>
            <NextBridWrapper>
                <p className={h3()}>Drugi artykuł w ramach tego BRIDa</p>
                <PhotoOnLeftLayout>
                    <Link to={href}>
                        <img src={backgroundSrc} />
                        <p className={bodyLarge()}>{title}</p>
                    </Link>
                </PhotoOnLeftLayout>
                <img className="atavist-dots" src={Dots} />
            </NextBridWrapper>
        </AtavistBridInfoWrapper>
    );
};



const AtavistBridInfoWrapper = styled("div", {
    maxWidth: "840px",
    width: "100%",
    background: "$grayscale0Fixed",
    "@bp4": {
        margin: "88px auto 80px auto",
    },
});


const NextBridWrapper = styled("div", {
    padding: "32px 24px 42px 24px",
    position: "relative",
    "@bp4": {
        padding: "48px 108px 56px 48px",
    },
    "p": {
        margin: 0,
    },
    ".atavist-dots": {
        position: "absolute",
        right: 0,
        bottom: 0,
        margin: 0,
        width: "30px",
        "@bp4": {
            width: "54px",
        }
    }
});

const PhotoOnLeftLayout = styled("div", {
    marginTop: "24px",

    "& a": {
        display: "flex",
    },

    "& img": {
        height: "72px",
        width: "108px",
        background: "#fff",
        position: "block",
        marginRight: "16px",
    },

    "& p": {
        maxWidth: "284px",
        marginRight: "16px",
        maxHeight: "72px",
        overflow: "hidden",
        fontSize: '14px',

        "@bp4": {
            fontSize: '16px',
        }
    }
});

export default AtavistNextBrid;
